import { render } from "./LoginForm.vue?vue&type=template&id=3a0e7966"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=3a0e7966&lang=scss"
script.render = render

export default script